<template>
  <q-pull-to-refresh @refresh="refresh">
    <q-card flat>
      <q-card-section class="no-padding">
        <q-banner class="bg-blue text-white" inline-actions>
          <q-input color="black" style="width: 100%" bg-color="white" type="search"
                   label="رهگیری سفارشات خرید..."
                   v-model="filter" filled dense>
            <template v-slot:append>
              <q-btn round flat icon="filter_alt"/>
            </template>
            <template v-slot:prepend>
              <q-avatar size="md" color="teal" text-color="white" icon="search"/>
            </template>
          </q-input>
        </q-banner>
      </q-card-section>
      <q-card-section :horizontal="!$q.screen.lt.md" class="no-padding">
        <BuyList :items="items.filter(item=> !item.Cs_ID)"
                 title="درخواست خرید"
                 :compact-view="true"
                 :is-dialog="false"
                 :is-searching="false"
                 :filter="filter"
                 @order-archived="orderArchived"/>
        <BuyList :items="items.filter(item=> item.Buy_State===0 && item.Cs_ID)"
                 title="استعلام"
                 :compact-view="true"
                 :is-dialog="false"
                 :is-searching="false"
                 :filter="filter" @order-archived="orderArchived"/>
        <BuyList :items="items.filter(item=> item.Buy_State===1 && !item.Factor_Num && item.Cs_ID)"
                 title="سفارش نهایی شده" :filter="filter"
                 :compact-view="true"
                 :is-dialog="false"
                 :is-searching="false"
                 @refresh-data="fillOrderTraceList" @order-archived="orderArchived"/>
        <BuyList :items="items.filter(item=> item.Factor_Buy_State===0 && item.Buy_State===1 && item.Cs_ID)"
                 title="در انتظار فاکتور نهایی"
                 :compact-view="true"
                 :is-dialog="false"
                 :is-searching="false"
                 :filter="filter" @refresh-data="fillOrderTraceList"/>
        <BuyList
            :items="items.filter(item=> item.Factor_Buy_State===1 && item.Buy_State===1 && !item.Recipt_Num && item.Cs_ID)"
            title="در انتظار صدور حواله ورود"
            :compact-view="true"
            :is-dialog="false"
            :is-searching="false"
            :filter="filter" @refresh-data="fillOrderTraceList"/>
        <BuyList
            :items="items.filter(item=> item.Factor_Buy_State===1 && item.Buy_State===1 && item.Recipt_Num && item.Recipt_State===1 && item.Cs_ID)"
            title="در انتظار صدور سند مالی"
            :compact-view="true"
            :is-dialog="false"
            :is-searching="false"
            @issue-finance-success="successIssueFinanceDocument"
            :filter="filter"/>

      </q-card-section>
    </q-card>

  </q-pull-to-refresh>
</template>

<script>
import BuyList from "@/components/Buys/BuyList";
import {mapActions} from "vuex";

export default {
  name: "BuyOrderTrace",
  components: {BuyList},
  data() {
    return {
      filter: undefined,
      items: [],

    }
  },
  methods: {
    ...mapActions({
      getOrderTrace: 'Buys/getOrderTraceListWithoutFinanceDocument'
    }),
    orderArchived(args) {
      const index = this.items.findIndex(item => {
        return (args.Buy_Num === item.Buy_Num && args.Buy_Kind === item.Buy_Kind)
      })
      this.$delete(this.items, index)
    },
    refresh(done) {
      this.getOrderTrace().then((res) => {
        this.items = res
        done()
      })
    },
    fillOrderTraceList() {
      this.getOrderTrace().then((res) => {
        this.items = res
      })
    },
    successIssueFinanceDocument(args) {
      const index = this.items.findIndex(item => {
        return (args.Buy_Num === item.Buy_Num && args.Buy_Kind === item.Buy_Kind)
      })
      this.$delete(this.items, index)
    }
  },
  created() {
    this.fillOrderTraceList()
  }
}
</script>

<style scoped>

</style>